import { UtcDate } from '@/helpers/date';

export default {
  validate (propertyYear) {
    const todayYear = new UtcDate().getFullYear();
    return {
      required: true,
      valid: propertyYear && Number(propertyYear) >= Number(this.constants.PROPERTY_BUILD_YEAR_MIN) && Number(propertyYear) <= todayYear,
    };
  },
  message (fieldName, { _value_: propertyYear }) {
    if (!propertyYear) return 'Please enter the year.';
    const todayYear = new UtcDate().getFullYear();
    if (Number(propertyYear) < Number(this.constants.PROPERTY_BUILD_YEAR_MIN) || Number(propertyYear) > todayYear) return `The year of build should be between ${this.constants.PROPERTY_BUILD_YEAR_MIN} & ${todayYear}.`;
  },
  computesRequired: true,
};
